import { Controller } from '@hotwired/stimulus';
import scrollIntoView from 'smooth-scroll-into-view-if-needed';
/*
 * Description
 * -------
 *
 * Scrolls to element on into view when it is focused.
 *
 * Can be used on any element.
 * Should be used only once in the document.
 *
 * Usage
 * -------
 *
 * <div data-controller="scroll-on-focus"></div>
 */
export class ScrollOnFocus extends Controller {
    scrollIntoView = () => {
        scrollIntoView(this.element, { behavior: 'smooth', inline: 'center', block: 'center' });
    };
    connect() {
        this.element.addEventListener('focus', this.scrollIntoView);
    }
    disconnect() {
        this.element.removeEventListener('focus', this.scrollIntoView);
    }
}
